import { Option } from "../../../../base/Select/Select";
import MinMaxSelect from "../../../../search-filter-options/MinMaxSelects/MinMaxSelects";

interface AcresOptionProps {
  min: number | undefined;
  max: number | undefined;
  onChange: (min?: number, max?: number) => void;
  className?: string;
}

const OPTIONS = [
  {
    value: 0.25,
    label: "0.25 acres",
  },
  {
    value: 0.5,
    label: "0.5 acres",
  },
  {
    value: 1,
    label: "1 acres",
  },
  {
    value: 2,
    label: "2 acres",
  },
  {
    value: 3,
    label: "3 acres",
  },
  {
    value: 4,
    label: "4 acres",
  },
  {
    value: 5,
    label: "5 acres",
  },
  {
    value: 10,
    label: "10 acres",
  },
  {
    value: 20,
    label: "20 acres",
  },
  {
    value: 40,
    label: "40 acres",
  },
  {
    value: 100,
    label: "100 acres",
  },
] satisfies Option[];

export default function AcresOption({ min, max, onChange, className }: AcresOptionProps) {
  return (
    <div>
      <MinMaxSelect
        groupLabel="Acres"
        minValue={min}
        maxValue={max}
        onChange={onChange}
        className={className}
        options={OPTIONS}
      />
    </div>
  );
}
